/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;
const KEY_F2 = 113;

export default class NumericEditor extends Component {
  constructor(props) {
    super(props);

    this.cancelBeforeStart =
      this.props.charPress && '1234567890'.indexOf(this.props.charPress) < 0;
    this.state = this.createInitialState(props);

    this.onKeyDown = this.onKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isCancelAfterEnd = this.isCancelAfterEnd.bind(this);
    this.getCharCodeFromEvent = this.getCharCodeFromEvent.bind(this);
    this.isLeftOrRight = this.isLeftOrRight.bind(this);
  }

  componentDidMount() {
    this.nv.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    this.nv.removeEventListener('keydown', this.onKeyDown);
  }

  // will reject the number if it greater than 1,000,000
  // not very practical, but demonstrates the method.

  onKeyDown(event) {
    if (this.isLeftOrRight(event) || this.deleteOrBackspace(event)) {
      event.stopPropagation();
      return;
    }

    if (!this.isKeyPressedNumeric(event)) {
      if (event.preventDefault) event.preventDefault();
    }
  }

  getValue() {
    const { value } = this.state;
    return value;
  }

  getCharCodeFromEvent(event) {
    event = event || window.event;
    return typeof event.which === 'undefined' ? event.keyCode : event.which;
  }

  handleChange(event) {
    let value = event.target.value;
    if (value && !isNaN(parseInt(event.target.value))) {
      value = parseInt(event.target.value);
    }
    this.setState({ value });
  }

  isLeftOrRight(event) {
    return [37, 39].indexOf(event.keyCode) > -1;
  }

  isCancelAfterEnd() {
    const { value } = this.state;
    return value > 10000000000;
  }

  isCancelBeforeStart() {
    return this.cancelBeforeStart;
  }

  afterGuiAttached() {
    // get ref from React component
    const eInput = this.nv;
    const { highlightAllOnFocus } = this.state;
    eInput.focus();
    if (highlightAllOnFocus) {
      eInput.select();

      this.setState({
        highlightAllOnFocus: false
      });
    } else {
      // when we started editing, we want the carot at the end, not the start.
      // this comes into play in two scenarios: a) when user hits F2 and b)
      // when user hits a printable character, then on IE (and only IE) the carot
      // was placed after the first character, thus 'apply' would end up as 'pplea'
      const length = eInput.value ? eInput.value.length : 0;
      if (length > 0) {
        eInput.setSelectionRange(length, length);
      }
    }
  }

  isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
  }

  createInitialState(props) {
    let startValue;
    let highlightAllOnFocus = true;

    if (props.keyPress === KEY_BACKSPACE || props.keyPress === KEY_DELETE) {
      // if backspace or delete pressed, we clear the cell
      startValue = '';
    } else if (props.charPress) {
      // if a letter was pressed, we start with the letter
      startValue = props.charPress;
      highlightAllOnFocus = false;
    } else {
      // otherwise we start with the current value
      startValue = props.value;
      if (props.keyPress === KEY_F2) {
        highlightAllOnFocus = false;
      }
    }

    return {
      value: startValue,
      highlightAllOnFocus
    };
  }

  isKeyPressedNumeric(event) {
    const charCode = this.getCharCodeFromEvent(event);
    const charStr = event.key ? event.key : String.fromCharCode(charCode);
    return this.isCharNumeric(charStr);
  }

  deleteOrBackspace(event) {
    return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
  }

  render() {
    const { value } = this.state;
    return (
      <input
        ref={elem => (this.nv = elem)}
        value={value || value === 0 ? value : ''}
        onChange={this.handleChange}
        style={{ width: '100%' }}
      />
    );
  }
}

NumericEditor.propTypes = {
  charPress: PropTypes.any
};
